import PullTo from 'vue-pull-to'
import emptyImage from '@/assets/empty.png'
import utils from '@/js/utils'
import service from '@/js/service'
export const mixins = {
  components: {
    PullTo
  },
  props: {
    view: {
      type: Object,
      default() {
        return {}
      }
    },
    state: {
      type: Object,
      default() {
        return {}
      }
    },
    db: {
      type: Object,
      default() {
        return {}
      }
    },
    file: {
      type: Object,
      default() {
        return {}
      }
    },
    mod: {
      type: String,
      default() {
        return 'mine'
      }
    },
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    thumbSize: {
      type: Number,
      default: 380
    },
    columnNums: {
      type: Number,
      default: 0
    },
    fixHeight: {
      type: Number,
      default: 95
    },
    pageSize: {
      type: Number,
      default: 30
    },
    loginStatus: {
      type: Boolean,
      default: false
    },
    loginUserId: {
      type: Number,
      default: 0
    },
    subtractHeight: {
      type: Number,
      default: 0
    },
    topPull: {
      type: Boolean,
      default: true
    },
    bottomPull: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const schema = {
      scrollTop: 0,
      // 瀑布流各列数据
      columns: [],
      horizWidth: 0,
      items: [],
      task_logs: {},
      currentPage: 0,
      cursorValue: 0,
      cursorValueUp: 0,
      cursorValueDown: 0,
      cursorSkipUp: 0,
      cursorSkipDown: 0,
      skip: 0,
      noUpPage: false,
      noDownPage: false
    }
    let container_width, container_height
    if (this.state.platform.type === 'desktop' && this.view.task.pop) {
      container_width = utils.popWidth()
      container_height = utils.popHeight()
    } else {
      container_width = utils.width()
      container_height = utils.height()
    }
    const data = {
      container_width: container_width,
      container_height: container_height,
      width: container_width - 3,
      height: container_height - 95,
      // 水平局部时限制缩略图尺寸和水平宽度
      maxThumbWidth: 160,
      maxThumbHeight: 80,
      renew: false,
      // 达到保留页数时，重新渲染列表
      remainPages: 100,
      showUp: false,
      emptyImage: emptyImage,
      schema: schema,
      dt: {
        'mine': utils.deepClone(schema),
        'new': utils.deepClone(schema),
        'finish': utils.deepClone(schema)
      },
      loading: {
        'mine': false,
        'new': false,
        'finish': false
      }
    }
    return data
  },
  computed: {
    isMobile() {
      return this.state.platform.type === 'mobile'
    },
    reqId() {
      return this.state.reqId
    },
    itemSize() {
      if (this.columnNums) return Math.floor(this.width / this.columnNums) - 10
      return this.thumbSize
    },
    mainWidth() {
      if (this.config.pop) {
        return this.width
      } else {
        return this.isDesktop && this.view.mainLeftSide ? this.width - this.view.mainLeftSideWidth : this.width
      }
    },
    maxColumns() {
      return Math.max(Math.floor(this.mainWidth / (this.itemSize + 10)), 1)
    },
    columnWidth() {
      return Math.round(this.mainWidth / this.maxColumns)
    },
    cardWidth() {
      return this.columnWidth - 10
    },
    // 瀑布流高度
    flowHeight() {
      let height = 0
      for (let i = 0; i < this.columns.length; i++) {
        const its = this.columns[i].items
        const colHeight = its[its.length - 1]._height + its[its.length - 1]._top
        if (colHeight > height) height = colHeight
      }
      return height
    },
    headHeight() {
      return this.config.showHead ? 40 : 0
    },
    listStyle() {
      if (this.subtractHeight) return { 'height': 'calc(100% - ' + this.subtractHeight + 'px)', 'margin-top': '5px' }
      return { 'height': 'calc(100% - ' + (45 + this.headHeight) + 'px)', 'margin-top': (45 + this.headHeight) + 'px' }
    },
    config() {
      return this.view.task
    },
    users() {
      return this.state.users
    },
    data() {
      return this.dt[this.mod]
    },
    itemNums() {
      return this.data.items.length
    },
    columns() {
      return this.data ? this.data.columns : []
    },
    followState() {
      return this.state.followState || {}
    },
    limit() {
      let limit = this.pageSize
      if (!this.isMobile) limit = limit * 2
      return limit
    }
  },
  watch: {
    'view.mainLeftSide': {
      handler() {
        this.onResize()
      }
    },
    // 'view.task.show': {
    //   handler(show) {
    //     this.update()
    //     if (this.config.type === this.mod && show) {
    //       this.calcTaskState()
    //       if (!this.itemNums) this.getData('down')
    //     }
    //   }
    // },
    'view.task.type': {
      handler() {
        if (this.config.type === this.mod && this.config.show) {
          this.calcTaskState()
          if (!this.config.pop) this.emit('setLocationHash')
          if (!this.itemNums) this.getData('down')
        }
      }
    }
  },
  mounted() {
    if (!this.loginUserId) {
      this.emit('login')
      return
    }
    this.calcSize()
    const container = this.scrollContainer()
    if (container) container.onscroll = () => { this.data.scrollTop = container.scrollTop }
    window.addEventListener('resize', this.onResize)
    if (this.config.type === this.mod && this.config.show && !this.itemNums) {
      this.getData('down')
    }
  },
  methods: {
    // 计算任务状态
    async calcTaskState(items, refresh = true) {
      if (this.mod === 'mine') {
        items = items || this.data.items
        const finishItems = []
        const doingItems = []
        let tmpItems = []
        const unfinishItems = []
        for (const i in items) {
          let state = await this.checkTaskState(items[i].verify_conf)
          state = items[i].auto_finish ? [1, 1] : state
          items[i].state = state
          items[i].finish = (state.length === 2 && state[0] >= state[1])
          if (items[i].finish) {
            finishItems.push(items[i])
          } else if (state[0] > 0) {
            tmpItems.push([state[0], items[i]])
          } else {
            unfinishItems.push(items[i])
          }
        }
        if (tmpItems.length) {
          tmpItems = utils.sortArr(tmpItems, 0)
          for (const i in tmpItems) {
            doingItems.push(tmpItems[i][1])
          }
        }
        this.data.items = finishItems.concat(doingItems).concat(unfinishItems)
        this.renderItems(this.data.items, refresh)
        this.update()
      }
    },
    async checkTaskState(verify_conf) {
      let state = []
      if (verify_conf) {
        for (var key in verify_conf) {
          if (key && verify_conf[key]) {
            verify_conf[key] = verify_conf[key] === true ? 1 : parseInt(verify_conf[key])
            const ret = await service.getCount(this.loginUserId, key)
            state = [ret && ret.count ? ret.count : 0, verify_conf[key]]
          }
        }
      }
      return state
    },
    // 清除任务数据
    cleanTaskState(verify_conf) {
      if (verify_conf) {
        for (var key in verify_conf) {
          service.setCount(this.loginUserId, key, 0)
        }
      }
    },
    getTaskCount(state) {
      if (state && state.length === 2) {
        if (state[0] >= state[1]) {
          return '<span class="green">[' + this.$t('i.finish') + ']</span>'
        } else {
          return '<span class="yellow">' + state[0] + '/' + state[1] + '</span>'
        }
      }
      return ''
    },
    // 转场
    goto(mod, dt) {
      this.emit('goto', [mod, dt])
    },
    // 移除
    removeItem(id) {
      for (var i in this.data.items) {
        if (this.data.items[i].task_typeid === id) {
          this.data.items.splice(i, 1)
        }
      }
      this.renderItems(this.data.items, true)
    },
    // 设置属性
    setItem(id, key, value) {
      for (var i in this.data.items) {
        if (this.data.items[i].task_typeid === id) {
          this.data.items[i][key] = value
          return this.data.items[i]
        }
      }
    },
    scrollContainer() {
      const main = document.getElementById('task-' + this.mod + '-container')
      if (main) {
        const scroll = main.getElementsByClassName('scroll-container')
        if (scroll.length) return scroll[0]
      }
    },
    onResize() {
      if (!this.config.show && !this.view.relation.show && !this.view.invite.show && !this.view.discover.show && !this.view.index.show) return
      this.calcSize()
      // this.backTop()
      // this.data.scrollTop = 0
      this.renderItems(this.data.items, true)
    },
    backTop() {
      const container = this.scrollContainer()
      if (container) {
        setTimeout(() => {
          container.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
        }, 100)
      }
    },
    renewView() {
      this.backTop()
      this.loadData(() => {}, 'renew')
    },
    showItem(item) {
      if (item._top <= this.data.scrollTop - this.height && item._top + item._height >= this.data.scrollTop - this.height) return true
      if (item._top >= this.data.scrollTop - this.height && item._top <= this.data.scrollTop + this.height + this.height) return true
      return false
    },
    formateTime: utils.formateTime,
    formateNums: utils.formateNums,
    // 调用父组件方法
    emit(fn, params) {
      if (!fn) return
      this.$emit('receive', fn, params || [])
    },
    // 提示信息
    message(msg, type) {
      this.emit('message', [msg, type])
    },
    // 确认操作
    confirm(msg, fn, title) {
      this.emit('confirm', [msg, fn, title])
    },
    getMinHeight(arr) {
      const a = []
      for (let i = 0; i < arr.length; i++) {
        a.push(parseInt(arr[i]._height) + parseInt(arr[i]._top))
      }
      return Math.min.apply(null, a)
    },
    getMinIndex(val) {
      const arrIndex = []
      for (let i = 0; i < this.columns.length; i++) {
        const its = this.columns[i].items
        const height = its[its.length - 1]._height
        const top = its[its.length - 1]._top
        if (parseInt(height) + parseInt(top) === val) {
          arrIndex.push(i)
        }
      }
      return arrIndex
    },
    calcItemSize() {
      // 水平布局
      if (this.mod === 'index') {
        this.data.horizWidth = this.data.horizWidth + this.maxThumbWidth + 10
        return { width: this.maxThumbWidth, height: 0 }
      }
      return { width: this.itemSize, height: 0 }
    },
    renderItems(items, refresh = false) {
      if (refresh) {
        this.data.columns = []
        this.data.horizWidth = 0
      }
      if (!items.length) return
      // 初始化列、列的第一个元素
      let idx = 0
      if (this.columns.length < this.maxColumns || refresh) {
        for (let i = 0; i < this.maxColumns; i++) {
          if (!this.columns[i] && items[idx]) {
            const itemSize = this.calcItemSize()
            items[idx]._top = 0
            items[idx]._raw_width = itemSize.width
            items[idx]._raw_height = itemSize.height
            items[idx]._height = items[idx]._raw_height + this.fixHeight
            this.columns.push({ items: [items[idx]] })
            idx++
          }
        }
      }
      // 对剩余元素的判断，应该放到哪一列
      for (var index = idx; index < items.length; index++) {
        // 找到高度最小的一列，可能有多个
        const tmp = []
        for (let i = 0; i < this.columns.length; i++) {
          const its = this.columns[i].items
          tmp.push({
            _height: its[its.length - 1]._height,
            _top: its[its.length - 1]._top
          })
        }
        // 获取最矮的列高度
        const minHeight = this.getMinHeight(tmp)
        // 获取最矮列的索引
        let minHeightIdx = 0
        const arrIndex = this.getMinIndex(minHeight)
        // 出现高度一样的，取索引最小的
        if (arrIndex.length > 0) {
          minHeightIdx = Math.min.apply(null, arrIndex)
        }
        // 设置属性
        const itemSize = this.calcItemSize()
        items[index]._top = minHeight
        items[index]._raw_width = itemSize.width
        items[index]._raw_height = itemSize.height
        items[index]._height = items[index]._raw_height + this.fixHeight
        this.columns[minHeightIdx].items.push(items[index])
      }
    },
    calcSize() {
      if (this.state.platform.type === 'desktop' && this.view.task.pop) {
        this.container_width = utils.popWidth()
        this.container_height = utils.popHeight()
      } else {
        this.container_width = utils.width()
        this.container_height = utils.height()
      }
      this.width = this.container_width - 3
      this.height = this.container_height - 95 - this.headHeight
    },
    init(backTop) {
      if (backTop) this.backTop()
      this.dt[this.mod] = utils.deepClone(this.schema)
    },
    update() {
      this.$forceUpdate()
    },
    updateData(updateHash) {
      if (updateHash && !this.config.pop) this.emit('setLocationHash')
      if (!this.itemNums) {
        this.init()
        this.getData('down')
      } else {
        this.update()
      }
    },
    getBgStye(item) {
      const style = {}
      const bg = this.getBackground(item)
      if (bg) {
        style['background-image'] = 'url(' + bg + ')'
        style['background-position'] = 'center center'
        style['background-size'] = '100% auto'
        style['background-repeat'] = 'no-repeat'
      }
      return style
    },
    getAvatar(item) {
      const ver = Math.round(new Date(item.avatar_at) / 1000)
      if (item.avatar) return service.getCosUrl(item.avatar, 'avatar', ver) || ''
    },
    getBackground(item) {
      const ver = Math.round(new Date(item.background_at) / 1000)
      if (item.background) return service.getCosUrl(item.background, 'background', ver) || ''
    },
    getSign(content, split) {
      if (!content) return ''
      return utils.fomateContent(content, split)
    },
    // 10008：成长值  10007：晶钻  10006：晶石
    getPrizeInfo(prize_conf) {
      if (!prize_conf) return ''
      let prize = '<br>'
      if (prize_conf.tip) {
        prize = prize + prize_conf.tip + ' &nbsp; '
      } else {
        if (prize_conf['10008'] && prize_conf['10008'].nums) prize = prize + this.$t('i.growth') + '+' + prize_conf['10008'].nums + ' &nbsp; '
        if (prize_conf['10006'] && prize_conf['10006'].nums) prize = prize + this.$t('i.crystal') + '+' + prize_conf['10006'].nums + ' &nbsp; '
        if (prize_conf['10007'] && prize_conf['10007'].nums) prize = prize + this.$t('i.diamond') + '+' + prize_conf['10007'].nums + ' &nbsp; '
      }
      return prize
    },
    getIcon(thumb) {
      return '<i class="color-ee iconfont ' + thumb + '">'
    },
    getThumb(item) {
      const ver = Math.round(new Date(item.add_at) / 1000)
      if (item.thumb) return service.getCosUrl(item.thumb, 'item_type_icon', ver) || ''
    },
    // 去完成任务
    doIt(item) {
      if (item.guide_conf && item.guide_conf.goto) this.emit('goto', item.guide_conf.goto)
    },
    // 放弃任务
    abandonIt(item) {
      this.confirm(this.$t('i.ifCancelTask'), (action) => {
        if (action === 'confirm') {
          const params = {
            type: 'abandon',
            id: item.task_typeid
          }
          service.actionGet('task', params, (dt, type) => {
            if (type === 'success') {
              this.removeItem(item.task_typeid)
              this.view.task.init = { 'new': utils.time('time') }
              this.message(this.$t('i.taskCancel'), type)
            } else {
              this.message(dt, type)
            }
          }, true)
          this.emit('traceEvent', ['abandonTask'])
        }
      })
    },
    // 接受任务
    acceptIt(item) {
      const params = {
        type: 'accept',
        id: item.task_typeid
      }
      service.actionGet('task', params, (dt, type) => {
        if (type === 'success') {
          this.removeItem(item.task_typeid)
          this.view.task.init = { 'mine': utils.time('time') }
          this.message(this.$t('i.taskAccepted'), type)
          this.emit('traceEvent', ['acceptTask'])
        } else {
          this.message(dt, type)
        }
      }, true)
    },
    // 完成任务
    finishIt(item) {
      const params = {
        type: 'finish',
        id: item.task_typeid
      }
      service.actionGet('task', params, (dt, type) => {
        if (type === 'success') {
          const gets = []
          for (const i in dt.data.items) {
            gets.push(dt.data.items[i].name + ' x' + dt.data.items[i].nums)
          }
          this.cleanTaskState(item.verify_conf)
          if (gets.length) {
            this.emit('alert', [gets.join('\n'), () => {
              this.emit('getSource')
              this.renewView()
            }, this.$t('i.gain')])
          } else {
            this.renewView()
          }
          this.emit('traceEvent', ['finishTask'])
        } else {
          this.message(dt, type)
        }
      }, true)
    },
    loadData(loaded, direction) {
      if (this.config.show) {
        this.renew = direction === 'renew'
        if (direction === 'renew') {
          direction = 'down'
          this.data.currentPage = 0
          this.data.cursorValue = 0
          this.data.cursorValueUp = 0
          this.data.cursorValueDown = 0
          this.data.cursorSkipUp = 0
          this.data.cursorSkipDown = 0
          this.data.skip = 0
          this.data.noUpPage = false
          this.data.noDownPage = false
        }
        this.getData(direction, () => {
          this.renew = false
          loaded('done')
        })
      }
    },
    // 分页读取数据
    async getData(direction, cb) {
      direction = direction || 'down'
      if (!this.config.show) return cb && cb()
      if (direction === 'up' && this.data.noUpPage) return cb && cb()
      if (direction === 'down' && this.data.noDownPage) return cb && cb()
      if (this.loading[this.mod]) return cb && cb()
      this.loading[this.mod] = true
      const params = {
        'sort_field': 'ordernum',
        'sort': 'asc',
        'limit': this.limit,
        'skip': direction === 'up' ? this.data.cursorSkipUp : this.data.cursorSkipDown,
        'cursor_value': direction === 'up' ? this.data.cursorValueUp : this.data.cursorValueDown,
        'direction': direction
      }
      params.mod = this.mod
      // console.error('params', this.mod, params, direction, this.data.currentPage, this.data)
      service.listGet('task', params, (res, type) => {
        if (type === 'success') {
          let refresh = false
          if (direction === 'up') {
            this.data.cursorValueUp = res.data.cursor_value_up
            this.data.cursorSkipUp = res.data.cursor_skip_up
            if (!this.data.cursorValueDown && !utils.isEmpty(res.data.cursor_value_down)) this.data.cursorValueDown = res.data.cursor_value_down
            this.data.noUpPage = utils.isEmpty(this.data.cursorValueUp)
            this.data.items = res.data.items.concat(this.data.items)
          } else if (direction === 'down') {
            if ((res.data.count === this.limit && this.data.currentPage >= this.remainPages) || this.renew) {
              if (res.data.count === this.limit && this.data.currentPage >= this.remainPages) {
                this.init(true)
                this.showUp = true
              } else {
                this.init()
              }
              refresh = true
            }
            this.data.currentPage++
            if (!this.data.cursorValueUp && !utils.isEmpty(res.data.cursor_value_up)) this.data.cursorValueUp = res.data.cursor_value_up
            this.data.cursorValueDown = res.data.cursor_value_down
            this.data.cursorSkipDown = res.data.cursor_skip_down
            this.data.noDownPage = utils.isEmpty(this.data.cursorValueDown)
            this.data.items = this.data.items.concat(res.data.items)
          }
          this.data.skip = utils.getInt(res.data.skip)
          if (this.mod === 'finish' && res.data.task_logs) {
            for (var task_logid in res.data.task_logs) {
              this.data.task_logs[task_logid] = res.data.task_logs[task_logid]
            }
          }
          if (direction === 'up') {
            this.renderItems(this.data.items, true)
          } else {
            if (this.mod === 'mine') {
              this.calcTaskState(this.data.items, refresh)
            } else {
              this.renderItems(res.data.items, refresh)
            }
          }
        } else {
          this.message(res, type)
        }
        cb && cb()
        this.loading[this.mod] = false
      }, false, false)
    }
  }
}
